import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import bode from './Assets/image.png';
import Content from './Components/Content';
import Domaines from './Components/Domaines';
import Footer from './Components/Footer';
import FormationTemplate from './Components/FormationTemplate';
import Home from './Components/Home';
import { HoverMenu } from './Components/HoverMenu';
import Navbar from './Components/Navbar';
import Plus from './Components/Plus';
import ScrollToTop from './Components/ScrollToTop';
import ScrollToTopButton from './Components/ScrollToTopButton';
import SearchableFormationList from './Components/SearchableFormationList';
import formations from './formations';

function App() {
  return (
    <Router>
      <div
        className=''
        style={{
          backgroundImage: `url(${bode})`
        }}
      >
        <ScrollToTop routes={['/', '/formation']} />
        <div className='fixed top-0 w-full z-50'>
          <Navbar />
        </div>

        <Content />
        <HoverMenu />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/plus' element={<Plus />} />
          <Route path='/domaines' element={<Domaines />} />
          <Route
            path='/formations'
            element={<SearchableFormationList />}
          />

          {Array.isArray(formations) && formations.map((module) => (
            <Route
              key={module.id}
              path={`/formation/${module.id}`}
              element={<FormationTemplate module={module} />}
            />
          ))}
        </Routes>
        <ScrollToTopButton />
        <Footer />
      </div>
    </Router>
  );
}

export default App;